import { post } from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { ImportEntityType } from '../typings'

type Props = {
  name: string
  description: string
  entityType: ImportEntityType
}

export async function importSetup(props: Props) {
  const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.import.save}`
  try {
    const response = await post(url, props)

    if (response.ok) {
      const tempApiKey: string = await response.json()
      return tempApiKey
    }
  } catch {
    return null
  }
}
